import axios from 'axios';

export const detectUserRegion = async () => {
  try {
    // 使用免费的 IP 地理位置 API
    const response = await axios.get('https://ipapi.co/json/');
    return response.data.country_code; // 返回国家代码，如 CN, US 等
  } catch (error) {
    console.error('IP detection failed:', error);
    return 'CN'; // 默认返回中国
  }
};